import React from 'react';
import Parser from 'html-react-parser';
import './styles.scss';

/* interface TableInfoProps {
  title: ReactNode | string;
  rows: { label: String, value: string }[];
} */

interface TableInfoProps {
  title?: React.ReactNode | string;
  rows: { label: React.ReactNode | string; value: string }[];
}

const TableInfo = ({ title, rows = [] }: TableInfoProps) => {
  return (
    <div className="table_info">
      {title && <div className="table_info_title">{title}</div>}
      <div className="table_info_content">
        {rows.map((row, idx) => (
          <div key={`${row.label}`} className={`table_info_row ${idx ? 'table_info_row_border_top' : ''}`}>
            <div className="table_info_row_label">{row.label}</div>
            <div className="table_info_row_value">{row.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TableInfo;
